<script setup lang="ts">
const TEXT = {
  show: 'Показать все',
  hide: 'Скрыть',
}

type Props = {
  showAllAdditives: boolean
}

const props = defineProps<Props>()

const emit = defineEmits(['toggleAdditives'])

const { isMobile } = useResponsive()

const text = computed(() => {
  if (isMobile.value) return TEXT.show

  return props.showAllAdditives ? TEXT.hide : TEXT.show
})

const toggleAdditives = () => emit('toggleAdditives')
</script>

<template>
  <div class="button-wrapper">
    <the-button
      class="button-wrapper__button"
      variant="transparent"
      size="sm"
      font="sm"
      type="button"
      @click="toggleAdditives"
    >
      {{ text }}

      <template #append>
        <the-icon
          class="button-wrapper__icon"
          :class="{
            'button-wrapper__icon--rotate': showAllAdditives && !isMobile,
          }"
          name="expand-down"
          color="var(--ui-primary)"
        />
      </template>
    </the-button>
  </div>
</template>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-start;

  &__button {
    display: flex;
    align-items: center;
  }

  &__icon {
    &--rotate {
      transform: rotate(-180deg);
    }
  }
}
</style>
